export const DEFAULT_SORT = [
  { id: 'position', desc: false },
  { id: 'alias', desc: false },
];
